import DatePicker from "react-date-picker";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomLoader from "../../components/loader/loader";
import SideBarWrapper from "../../components/sidebarWrapper/sideBarWrapper";
import { OK } from "../../config/axois/apiStatusCode";
import config from "../../config/config";
import { fetchAsyncDropdown, isDeleted, isEmpty } from "../../helper/helper";
import {
  dashboardSelector,
  fetchCurrentActivity,
  handleModal,
  setId,
  startActivity,
  stopActivity,
} from "../../redux/features/dashboard/dashboardSlice";
import {
  fetchSummary,
  summarySelector,
} from "../../redux/features/summary/summarySlice";
import { AppDispatch } from "../../redux/store";
import { ActivitiesType } from "../dashboard/dashboardType";
import { ActivityStop, ActivityType } from "../dashboard/type";
import {
  activityApi,
  dashboardApi,
  employeesApi,
  projectsApi,
} from "../../config/apiUrls/apiUrl";
import { AsyncPaginate } from "react-select-async-paginate";
import NoRecordFound from "../../components/no-record-found/NoRecordFound";
import { loginSelector } from "../../redux/features/auth/loginSlice";
import CustomPaginate from "../../components/pagination/CustomPaginate";
import { userSelector } from "../../redux/features/auth/userSlice";
import DeleteIcon from "../../components/delete/deleteIcon";
import { deleteModalSelector } from "../../redux/features/deleteModal/deleteModalSlice";
import { heading } from "../../redux/features/header/headerSlice";
import DeleteText from "../../components/delete/deleteText";
import instance from "../../config/axois/instance";
import { requestHeaders } from "../../config/axois/header";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const Summary = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { isLoading, summary } = useSelector(summarySelector);
  const { type } = useSelector(loginSelector);
  const { isClockIn, isStartActivityLoading, isStopActivityLoading } =
    useSelector(dashboardSelector);
  const { user } = useSelector(userSelector);

  const { reCallApi } = useSelector(deleteModalSelector);

  const isAdmin = type === "admin";

  const [selected, setSelected] = useState<number>(0);
  const [currentOffset, setCurrentOffset] = useState<number>(0);
  const [limit, setLimit] = useState<string>(config.LIMIT_PER_PAGE);
  const [count, setCount] = useState<number>(0);
  const [projectsOffset, setProjectsOffset] = useState("");
  const [projectsList, setProjectsList] = useState([]);
  const [projectsSearch, setProjectsSearch] = useState("");
  const [activityOffset, setActivityOffset] = useState("");
  const [activityList, setActivityList] = useState([]);
  const [activitySearch, setActivitySearch] = useState("");
  const [activity, setActivity] = useState<any>({
    label: "All Activity Types",
    value: "",
  });

  const [employeeOffset, setEmployeeOffset] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [employeeSearch, setEmployeeSearch] = useState("");
  const [employee, setEmployee] = useState<any>({
    label: "All Employee",
    value: "",
  });

  const [project, setProject] = useState<any>({
    label: "All Project",
    value: "",
  });
  const [startDate, setStartDate] = useState<Date | null>(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  );

  const [endDate, setEndDate] = useState<Date | null>(
    new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
  );
  const [openCalendar, setOpenCalendar] = useState(false);
  const calendarRef = useRef<HTMLDivElement>(null);

  const {
    currentActivities: { current_activity },
  } = useSelector(dashboardSelector);

  const startStopActivity = async (
    isCurrentActivity: boolean,
    item: ActivitiesType
  ) => {
    if (isCurrentActivity) {
      // stop activity logic
      const body: ActivityStop = {
        latitude: "-",
        longitude: "-",
        end_date_time: moment().format(config.API_DATE_TIME_FORMATE),
        id: current_activity?.id ?? "",
      };

      const response = await dispatch(stopActivity(body));

      if ([200, 201].includes(response?.payload?.status)) {
        await dispatch(fetchCurrentActivity());
        setCurrentOffset(0);
        setSelected(0);
      }
      return;
    }

    // start activity logic
    const body: ActivityType = {
      latitude: "-",
      longitude: "-",
      project_id: item.project_id,
      activity_type_id: item.activity_type_id,
      start_date_time: moment().format(config.API_DATE_TIME_FORMATE),
      end_date_time: null,
      description: item.description,
    };

    const response = await dispatch(startActivity(body));

    if ([200, 201].includes(response?.payload?.status)) {
      await dispatch(fetchCurrentActivity());
      fetchSummaryRecords();
      setCurrentOffset(0);
      setSelected(0);
    }
  };

  const fetchProjects = (search: any) => {
    return fetchAsyncDropdown(
      projectsOffset,
      setProjectsOffset,
      projectsList,
      setProjectsList,
      `${projectsApi.getProjects}?`,
      search,
      setProjectsSearch,
      false,
      true,
      "All Projects"
    );
  };

  const fetchActivity = (search: any) => {
    return fetchAsyncDropdown(
      activityOffset,
      setActivityOffset,
      activityList,
      setActivityList,
      `${activityApi.getActivities}?`,
      search,
      setActivitySearch,
      false,
      true,
      "All Activity Types"
    );
  };

  const fetchEmployee = (search: any) => {
    return fetchAsyncDropdown(
      employeeOffset,
      setEmployeeOffset,
      employeeList,
      setEmployeeList,
      `${employeesApi.getEmployees}?`,
      search,
      setEmployeeSearch,
      "full_name",
      true,
      "All Employee"
    );
  };

  useEffect(() => {
    fetchSummaryRecords();
  }, [
    project,
    activity,
    startDate,
    endDate,
    employee,
    limit,
    currentOffset,
    user,
  ]);

  useEffect(() => {
    if (reCallApi) fetchSummaryRecords();
  }, [reCallApi]);

  const fetchSummaryRecords = async () => {
    const response = await dispatch(
      fetchSummary({
        start_date: startDate ? moment(startDate).format("YYYY-MM-DD") : "",
        end_date: endDate ? moment(endDate).format("YYYY-MM-DD") : "",
        activity: activity?.value,
        project: project?.value,
        employee: isAdmin ? employee?.value : user?.id,
        limit: limit,
        offset: currentOffset,
        isDeleted: true,
      })
    );

    setCount(response?.payload?.data?.meta?.count ?? 0);
  };

  const downloadExcel = async () => {
    // Construct the URL with the same filters as fetchSummary but without limit and offset
    let url = `${dashboardApi.excelDownloadSummary}?project_id=${
      isEmpty(project?.value) ? "" : project?.value
    }&activity_type_id=${
      isEmpty(activity?.value) ? "" : activity?.value
    }&with_trashed=true`;

    if (startDate && !isEmpty(moment(startDate).format("YYYY-MM-DD"))) {
      url += `&start_date=${moment(startDate).format("YYYY-MM-DD")}`;
    }

    if (endDate && !isEmpty(moment(endDate).format("YYYY-MM-DD"))) {
      url += `&end_date=${moment(endDate).format("YYYY-MM-DD")}`;
    }

    if (!isEmpty(isAdmin ? employee?.value : user?.id)) {
      url += `&user_id=${isAdmin ? employee?.value : user?.id}`;
    }

    try {
      const response = await instance.get(url, {
        ...requestHeaders(true),
        responseType: "blob",
      });

      // Create a URL for the blob (response.data is already a Blob)
      const downloadUrl = window.URL.createObjectURL(response.data);

      // Create a temporary link to download the file
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute(
        "download",
        `summary-${moment().format("YYYY-MM-DD")}.xlsx`
      );
      document.body.appendChild(link);
      link.click();

      // Clean up
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading excel file:", error);
    }
  };

  const openModal = (id: string, isCurrentActivity: boolean) => {
    if (!isCurrentActivity) {
      dispatch(handleModal(true));
      dispatch(setId(id));
    }
  };

  useEffect(() => {
    dispatch(heading("Summary"));
  }, []);

  // Close calendar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target as Node)) {
        setOpenCalendar(false);
      }
    };

    if (openCalendar) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openCalendar]);

  return (
    <SideBarWrapper>
      <section
        style={{
          marginBottom: "-40px",
        }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="d-flex flex-wrap align-items-center mb-30">
                <AsyncPaginate
                  loadOptions={fetchProjects}
                  onChange={(e: any) => {
                    setProject(e);
                  }}
                  isSearchable={true}
                  placeholder="All Projects"
                  value={project}
                  className="react-select-container me-2 mb-lg-0 mb-2"
                  classNamePrefix="react-select"
                  isDisabled={isLoading}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: "#0c78a4",
                    },
                  })}
                />

                <AsyncPaginate
                  loadOptions={fetchActivity}
                  onChange={(e: any) => {
                    setActivity(e);
                  }}
                  isSearchable={true}
                  placeholder="All Activity Types"
                  value={activity}
                  isDisabled={isLoading}
                  className="react-select-container me-2 mb-lg-0 mb-2"
                  classNamePrefix="react-select"
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: "#0c78a4",
                    },
                  })}
                />

                {isAdmin && (
                  <AsyncPaginate
                    loadOptions={fetchEmployee}
                    onChange={(e: any) => {
                      setEmployee(e);
                    }}
                    isSearchable={true}
                    placeholder="All Employee"
                    value={employee}
                    isDisabled={isLoading}
                    className="react-select-container me-2 mb-lg-0 mb-2"
                    classNamePrefix="react-select"
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary: "#0c78a4",
                      },
                    })}
                  />
                )}

                <div className="position-relative me-3 mb-lg-0 mb-2" ref={calendarRef}>
                  <button
                    className="btn btn-outline-secondary d-flex align-items-center"
                    onClick={() => setOpenCalendar(!openCalendar)}
                    disabled={isLoading}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5 0zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                    </svg>
                    <span>
                      {startDate && endDate
                        ? `${moment(startDate).format("DD/MM/YYYY")} - ${moment(endDate).format("DD/MM/YYYY")}`
                        : "Select Date Range"}
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      fill="currentColor"
                      className="ms-2"
                      viewBox="0 0 16 16"
                    >
                      <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                    </svg>
                  </button>
                  
                  {openCalendar && (
                    <div 
                      className="position-absolute bg-white border rounded shadow-lg"
                      style={{
                        top: '100%',
                        left: '0',
                        zIndex: 1050,
                        marginTop: '4px',
                        minWidth: '600px',
                        maxWidth: '90vw'
                      }}
                    >
                      <DateRange
                        ranges={[
                          {
                            startDate: startDate!,
                            endDate: endDate!,
                            key: "selection",
                          },
                        ]}
                        maxDate={new Date()}
                        moveRangeOnFirstSelection={false}
                        onChange={(ranges: any) => {
                          setStartDate(ranges.selection.startDate);
                          setEndDate(ranges.selection.endDate);
                        }}
                        months={2}
                        direction="horizontal"
                      />
                      <div className="p-2 border-top d-flex justify-content-end">
                        <button
                          className="btn btn-sm btn-secondary me-2"
                          onClick={() => setOpenCalendar(false)}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() => setOpenCalendar(false)}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                <button
                  className="btn btn-primary mb-lg-0 mb-2 d-flex align-items-center"
                  onClick={downloadExcel}
                  disabled={isLoading}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="me-2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                    />
                  </svg>
                  <span>Download Excel</span>
                </button>
              </div>
            </div>

            {isLoading ? (
              <CustomLoader />
            ) : (
              <>
                {summary.length === 0 ? (
                  <NoRecordFound message="No Summary Found" />
                ) : (
                  summary &&
                  summary.length > 0 &&
                  summary.map(
                    ({ days, end_date, start_date, weekly_total_duration }) => {
                      return (
                        <div className="">
                          <div className="d-flex flex-wrap align-items-center justify-content-between py-13">
                            <p className="fs-md mb-lg-0 mb-2">
                              {isEmpty(start_date)
                                ? "-"
                                : moment(start_date).format(
                                    "DD MMMM YYYY"
                                  )}{" "}
                              To{" "}
                              {isEmpty(end_date)
                                ? "-"
                                : moment(end_date).format("DD MMMM YYYY")}
                            </p>
                            <p className="fs-md mb-lg-0 mb-2">
                              Week Total :{" "}
                              {isEmpty(weekly_total_duration)
                                ? "-"
                                : weekly_total_duration}{" "}
                            </p>
                          </div>
                          {days &&
                            days.length > 0 &&
                            days.map(
                              ({
                                date,
                                total_duration,
                                activities,
                                day_total_amount,
                              }) => {
                                return (
                                  <>
                                    <div className="mb-3">
                                      <div className="d-flex flex-wrap align-items-center justify-content-between total-time-tracking">
                                        <p className="fs-md">
                                          {isEmpty(date)
                                            ? "-"
                                            : moment(date).format(
                                                "DD MMMM YYYY"
                                              )}
                                        </p>
                                        <p className="fs-md">
                                          {isAdmin && (
                                            <span className="me-3">
                                              Total Cost:{" "}
                                              {isEmpty(day_total_amount)
                                                ? "-"
                                                : day_total_amount}
                                            </span>
                                          )}
                                          Total:{" "}
                                          {isEmpty(total_duration)
                                            ? "-"
                                            : total_duration}
                                        </p>
                                      </div>

                                      <div className="table-responsive dashboard-table">
                                        <table className="table table-hover table-bordered table-row-gray-100 align-baseline gs-0 gy-2 mt-2">
                                          <thead>
                                            <tr className="text-muted">
                                              {isAdmin && <th>Employee</th>}
                                              <th>Project</th>
                                              <th>Activity Type</th>
                                              <th>Description</th>
                                              <th>Start Time</th>
                                              <th>End Time</th>
                                              <th>Spent Time</th>
                                              {isAdmin && <th>Total Cost</th>}
                                              {!isEmpty(isClockIn) && (
                                                <th>Actions</th>
                                              )}
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {activities &&
                                              activities.length > 0 &&
                                              activities.map(
                                                (
                                                  item: ActivitiesType,
                                                  index
                                                ) => {
                                                  const isCurrentActivity =
                                                    current_activity?.id ===
                                                    item.id;

                                                  return (
                                                    <tr>
                                                      {isAdmin && (
                                                        <td
                                                          className={`${
                                                            isCurrentActivity
                                                              ? "fw-bold"
                                                              : ""
                                                          }`}
                                                          style={{
                                                            color: !isEmpty(
                                                              item.deleted_at
                                                            )
                                                              ? "#aba9a6"
                                                              : "",
                                                          }}
                                                          onClick={() =>
                                                            isEmpty(
                                                              item.deleted_at
                                                            ) &&
                                                            openModal(
                                                              item.id,
                                                              isCurrentActivity
                                                            )
                                                          }
                                                          role={
                                                            !isCurrentActivity
                                                              ? "button"
                                                              : ""
                                                          }
                                                        >
                                                          {isEmpty(
                                                            item.employee_name
                                                          )
                                                            ? "-"
                                                            : item.employee_name}

                                                          {!isEmpty(
                                                            item.deleted_at
                                                          )
                                                            ? " - "
                                                            : ""}

                                                          {!isEmpty(
                                                            item.deleted_at
                                                          ) ? (
                                                            <DeleteText />
                                                          ) : (
                                                            ""
                                                          )}
                                                        </td>
                                                      )}
                                                      <td
                                                        onClick={() =>
                                                          isEmpty(
                                                            item.deleted_at
                                                          ) &&
                                                          openModal(
                                                            item.id,
                                                            isCurrentActivity
                                                          )
                                                        }
                                                        role={
                                                          !isCurrentActivity
                                                            ? "button"
                                                            : ""
                                                        }
                                                        className={`${
                                                          isCurrentActivity
                                                            ? "fw-bold"
                                                            : ""
                                                        }`}
                                                        style={{
                                                          color: !isEmpty(
                                                            item.deleted_at
                                                          )
                                                            ? "#aba9a6"
                                                            : "",
                                                        }}
                                                      >
                                                        {isEmpty(
                                                          item.project_name
                                                        )
                                                          ? "-"
                                                          : item.project_name}

                                                        {!isAdmin && (
                                                          <>
                                                            {!isEmpty(
                                                              item.deleted_at
                                                            )
                                                              ? " - "
                                                              : ""}

                                                            {!isEmpty(
                                                              item.deleted_at
                                                            ) ? (
                                                              <DeleteText />
                                                            ) : (
                                                              ""
                                                            )}
                                                          </>
                                                        )}
                                                      </td>
                                                      <td
                                                        onClick={() =>
                                                          isEmpty(
                                                            item.deleted_at
                                                          ) &&
                                                          openModal(
                                                            item.id,
                                                            isCurrentActivity
                                                          )
                                                        }
                                                        role={
                                                          !isCurrentActivity
                                                            ? "button"
                                                            : ""
                                                        }
                                                        className={`${
                                                          isCurrentActivity
                                                            ? "fw-bold"
                                                            : ""
                                                        }`}
                                                        style={{
                                                          color: !isEmpty(
                                                            item.deleted_at
                                                          )
                                                            ? "#aba9a6"
                                                            : "",
                                                        }}
                                                      >
                                                        {isEmpty(
                                                          item.activity_type
                                                        )
                                                          ? "-"
                                                          : item.activity_type}
                                                      </td>
                                                      <td
                                                        onClick={() =>
                                                          isEmpty(
                                                            item.deleted_at
                                                          ) &&
                                                          openModal(
                                                            item.id,
                                                            isCurrentActivity
                                                          )
                                                        }
                                                        role={
                                                          !isCurrentActivity
                                                            ? "button"
                                                            : ""
                                                        }
                                                        className={`${
                                                          isCurrentActivity
                                                            ? "fw-bold"
                                                            : ""
                                                        }`}
                                                        style={{
                                                          color: !isEmpty(
                                                            item.deleted_at
                                                          )
                                                            ? "#aba9a6"
                                                            : "",
                                                        }}
                                                      >
                                                        {isEmpty(
                                                          item.description
                                                        )
                                                          ? "-"
                                                          : item.description}
                                                      </td>
                                                      <td
                                                        onClick={() =>
                                                          isEmpty(
                                                            item.deleted_at
                                                          ) &&
                                                          openModal(
                                                            item.id,
                                                            isCurrentActivity
                                                          )
                                                        }
                                                        role={
                                                          !isCurrentActivity
                                                            ? "button"
                                                            : ""
                                                        }
                                                        className={`${
                                                          isCurrentActivity
                                                            ? "fw-bold text-center"
                                                            : "text-center"
                                                        }`}
                                                        style={{
                                                          color: !isEmpty(
                                                            item.deleted_at
                                                          )
                                                            ? "#aba9a6"
                                                            : "",
                                                        }}
                                                      >
                                                        {isEmpty(
                                                          item.start_date_time
                                                        )
                                                          ? "-"
                                                          : moment(
                                                              item.start_date_time
                                                            ).format("LT")}
                                                      </td>
                                                      <td
                                                        onClick={() =>
                                                          isEmpty(
                                                            item.deleted_at
                                                          ) &&
                                                          openModal(
                                                            item.id,
                                                            isCurrentActivity
                                                          )
                                                        }
                                                        role={
                                                          !isCurrentActivity
                                                            ? "button"
                                                            : ""
                                                        }
                                                        className={`${
                                                          isCurrentActivity
                                                            ? "fw-bold text-center"
                                                            : "text-center"
                                                        }`}
                                                        style={{
                                                          color: !isEmpty(
                                                            item.deleted_at
                                                          )
                                                            ? "#aba9a6"
                                                            : "",
                                                        }}
                                                      >
                                                        {isEmpty(
                                                          item.end_date_time
                                                        )
                                                          ? "-"
                                                          : moment(
                                                              item.end_date_time
                                                            ).format("LT")}
                                                      </td>
                                                      <td
                                                        onClick={() =>
                                                          isEmpty(
                                                            item.deleted_at
                                                          ) &&
                                                          openModal(
                                                            item.id,
                                                            isCurrentActivity
                                                          )
                                                        }
                                                        role={
                                                          !isCurrentActivity
                                                            ? "button"
                                                            : ""
                                                        }
                                                        className={`${
                                                          isCurrentActivity
                                                            ? "fw-bold text-center"
                                                            : "text-center"
                                                        }`}
                                                        style={{
                                                          color: !isEmpty(
                                                            item.deleted_at
                                                          )
                                                            ? "#aba9a6"
                                                            : "",
                                                        }}
                                                      >
                                                        {isEmpty(
                                                          item.total_duration
                                                        )
                                                          ? "-"
                                                          : item.total_duration}
                                                      </td>
                                                      {isAdmin && (
                                                        <td
                                                          onClick={() =>
                                                            isEmpty(
                                                              item.deleted_at
                                                            ) &&
                                                            openModal(
                                                              item.id,
                                                              isCurrentActivity
                                                            )
                                                          }
                                                          role={
                                                            !isCurrentActivity
                                                              ? "button"
                                                              : ""
                                                          }
                                                          className={`${
                                                            isCurrentActivity
                                                              ? "fw-bold text-center"
                                                              : "text-center"
                                                          }`}
                                                          style={{
                                                            color: !isEmpty(
                                                              item.deleted_at
                                                            )
                                                              ? "#aba9a6"
                                                              : "",
                                                          }}
                                                        >
                                                          {isEmpty(
                                                            item.total_amount
                                                          )
                                                            ? "-"
                                                            : item.total_amount}
                                                        </td>
                                                      )}
                                                      {!isEmpty(isClockIn) && (
                                                        <td>
                                                          <div className="text-center">
                                                            {isEmpty(
                                                              item.deleted_at
                                                            ) ? (
                                                              <>
                                                                <DeleteIcon
                                                                  url={employeesApi.deleteEmployee.replace(
                                                                    ":id",
                                                                    item.id
                                                                  )}
                                                                />
                                                                {item.is_resumable_activity && (
                                                                  <img
                                                                    role="button"
                                                                    onClick={() => {
                                                                      let loading =
                                                                        isStartActivityLoading ||
                                                                        isStopActivityLoading ||
                                                                        isLoading;

                                                                      !loading &&
                                                                        startStopActivity(
                                                                          isCurrentActivity,
                                                                          item
                                                                        );
                                                                    }}
                                                                    src={`../img/svg/${
                                                                      isCurrentActivity
                                                                        ? "icon-pause-filled-red.svg"
                                                                        : "Play-filled.svg"
                                                                    }`}
                                                                    alt="play"
                                                                    title={
                                                                      isCurrentActivity
                                                                        ? "Stop Activity"
                                                                        : "Start Activity"
                                                                    }
                                                                    width={24}
                                                                    height={24}
                                                                    loading="eager"
                                                                    className=""
                                                                  />
                                                                )}
                                                              </>
                                                            ) : (
                                                              ""
                                                            )}
                                                          </div>
                                                        </td>
                                                      )}
                                                    </tr>
                                                  );
                                                }
                                              )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </>
                                );
                              }
                            )}
                        </div>
                      );
                    }
                  )
                )}
              </>
            )}
          </div>
        </div>
      </section>

      <CustomPaginate
        data={summary}
        selected={selected}
        setSelected={setSelected}
        setCurrentOffset={setCurrentOffset}
        totalRecords={count}
        limit={limit}
        setLimit={setLimit}
        isDisable={isLoading}
        isLimitDropDown={true}
        hideEntries={true}
      />
    </SideBarWrapper>
  );
};

export default Summary;
